/*
 * @Author: caizr 13149329917@163.com
 * @Date: 2023-01-10 16:29:23
 * @LastEditors: caizr 13149329917@163.com
 * @LastEditTime: 2023-01-12 16:31:03
 * @FilePath: \cladogram\src\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '../utils/http';
//
/**
 *   resquest 请求地址 例如：http://192.168.120.100:8088/official/...
 *   '/api'代表vue-cil中config，index.js中配置的代理
 */

// // get请求
// export function getListAPI(params){
//     return http.get(`${resquest}/getList.json`,params)
// }
// post请求
export function save(params) {
  console.log('====================================');
  console.log(params);
  console.log('====================================');
  return http.post(`/official/customer/info/save`, params);
}
// // put 请求
// export function putSomeAPI(params){
//     return http.put(`${resquest}/putSome.json`,params)
// }
// // delete 请求
// export function deleteListAPI(params){
//     return http.delete(`${resquest}/deleteList.json`,params)
// }



// WEBPACK FOOTER //
// ./src/api/api.js